// Color Palette - Blue, Grey, Beige
export const COLORS = {
  // Surface/text roles resolve from the platform theme layer so they follow
  // dark/light automatically. Chart series stay literal hex.
  primary: '#2563EB',      // Royal Blue
  secondary: '#38BDF8',    // Sky Ice
  accent: 'var(--text-primary)',
  success: '#0284C7',      // Sky - brand forbids green
  warning: '#F59E0B',      // Amber
  danger: '#EF4444',       // Red
  light: 'var(--bg-subtle)',
  muted: 'var(--text-muted)',
  background: 'var(--bg-canvas)',
};

export const CATEGORY_COLORS = {
  'Education': '#3B82F6', 'Health Care': '#EF4444', 'Human Services': '#38BDF8',
  'Environment': '#0EA5E9', 'Arts, Culture & Humanities': '#8B5CF6',
  'Animal-Related': '#F59E0B', 'Youth Development': '#6366F1', 'default': '#64748B'
};

export const CHART_COLORS = ['#2563EB', '#38BDF8', '#6366F1', '#818CF8', '#F59E0B', '#EF4444'];

export const US_STATES = [
  { code: 'AL', name: 'Alabama' }, { code: 'AK', name: 'Alaska' }, { code: 'AZ', name: 'Arizona' },
  { code: 'AR', name: 'Arkansas' }, { code: 'CA', name: 'California' }, { code: 'CO', name: 'Colorado' },
  { code: 'CT', name: 'Connecticut' }, { code: 'DE', name: 'Delaware' }, { code: 'FL', name: 'Florida' },
  { code: 'GA', name: 'Georgia' }, { code: 'HI', name: 'Hawaii' }, { code: 'ID', name: 'Idaho' },
  { code: 'IL', name: 'Illinois' }, { code: 'IN', name: 'Indiana' }, { code: 'IA', name: 'Iowa' },
  { code: 'KS', name: 'Kansas' }, { code: 'KY', name: 'Kentucky' }, { code: 'LA', name: 'Louisiana' },
  { code: 'ME', name: 'Maine' }, { code: 'MD', name: 'Maryland' }, { code: 'MA', name: 'Massachusetts' },
  { code: 'MI', name: 'Michigan' }, { code: 'MN', name: 'Minnesota' }, { code: 'MS', name: 'Mississippi' },
  { code: 'MO', name: 'Missouri' }, { code: 'MT', name: 'Montana' }, { code: 'NE', name: 'Nebraska' },
  { code: 'NV', name: 'Nevada' }, { code: 'NH', name: 'New Hampshire' }, { code: 'NJ', name: 'New Jersey' },
  { code: 'NM', name: 'New Mexico' }, { code: 'NY', name: 'New York' }, { code: 'NC', name: 'North Carolina' },
  { code: 'ND', name: 'North Dakota' }, { code: 'OH', name: 'Ohio' }, { code: 'OK', name: 'Oklahoma' },
  { code: 'OR', name: 'Oregon' }, { code: 'PA', name: 'Pennsylvania' }, { code: 'RI', name: 'Rhode Island' },
  { code: 'SC', name: 'South Carolina' }, { code: 'SD', name: 'South Dakota' }, { code: 'TN', name: 'Tennessee' },
  { code: 'TX', name: 'Texas' }, { code: 'UT', name: 'Utah' }, { code: 'VT', name: 'Vermont' },
  { code: 'VA', name: 'Virginia' }, { code: 'WA', name: 'Washington' }, { code: 'WV', name: 'West Virginia' },
  { code: 'WI', name: 'Wisconsin' }, { code: 'WY', name: 'Wyoming' }, { code: 'DC', name: 'Washington D.C.' }
];

export const COUNTRIES = [
  { code: '', name: 'Select country...' },
  { code: 'US', name: 'United States' },
  { code: 'CA', name: 'Canada' },
  { code: 'GB', name: 'United Kingdom' },
  { code: 'AU', name: 'Australia' },
  { code: 'DE', name: 'Germany' },
  { code: 'FR', name: 'France' },
  { code: 'JP', name: 'Japan' },
  { code: 'CN', name: 'China' },
  { code: 'IN', name: 'India' },
  { code: 'BR', name: 'Brazil' },
  { code: 'MX', name: 'Mexico' },
  { code: 'ES', name: 'Spain' },
  { code: 'IT', name: 'Italy' },
  { code: 'NL', name: 'Netherlands' },
  { code: 'SE', name: 'Sweden' },
  { code: 'CH', name: 'Switzerland' },
  { code: 'SG', name: 'Singapore' },
  { code: 'HK', name: 'Hong Kong' },
  { code: 'KR', name: 'South Korea' },
  { code: 'AE', name: 'United Arab Emirates' },
  { code: 'ZA', name: 'South Africa' },
  { code: 'NZ', name: 'New Zealand' },
  { code: 'IE', name: 'Ireland' },
  { code: 'IL', name: 'Israel' },
  { code: 'AT', name: 'Austria' },
  { code: 'BE', name: 'Belgium' },
  { code: 'DK', name: 'Denmark' },
  { code: 'FI', name: 'Finland' },
  { code: 'NO', name: 'Norway' },
  { code: 'PL', name: 'Poland' },
  { code: 'PT', name: 'Portugal' },
  { code: 'RU', name: 'Russia' },
  { code: 'AR', name: 'Argentina' },
  { code: 'CL', name: 'Chile' },
  { code: 'CO', name: 'Colombia' },
  { code: 'ID', name: 'Indonesia' },
  { code: 'MY', name: 'Malaysia' },
  { code: 'PH', name: 'Philippines' },
  { code: 'TH', name: 'Thailand' },
  { code: 'VN', name: 'Vietnam' },
  { code: 'OTHER', name: 'Other' }
];

export const INDUSTRIES = [
  { value: '', label: 'Select your industry...' },
  { value: 'technology', label: 'Technology / Software' },
  { value: 'fintech', label: 'Financial Technology (FinTech)' },
  { value: 'ecommerce', label: 'E-Commerce / Retail Tech' },
  { value: 'saas', label: 'SaaS / Cloud Services' },
  { value: 'ai_ml', label: 'AI / Machine Learning' },
  { value: 'cybersecurity', label: 'Cybersecurity' },
  { value: 'banking', label: 'Banking / Financial Services' },
  { value: 'insurance', label: 'Insurance' },
  { value: 'consulting', label: 'Consulting / Advisory' },
  { value: 'legal', label: 'Legal Services' },
  { value: 'accounting', label: 'Accounting / Tax Services' },
  { value: 'real_estate', label: 'Real Estate / Property' },
  { value: 'healthcare', label: 'Healthcare / Hospitals' },
  { value: 'pharmaceuticals', label: 'Pharmaceuticals / Biotech' },
  { value: 'medical_devices', label: 'Medical Devices' },
  { value: 'mental_health', label: 'Mental Health Services' },
  { value: 'manufacturing', label: 'Manufacturing' },
  { value: 'automotive', label: 'Automotive' },
  { value: 'aerospace', label: 'Aerospace / Defense' },
  { value: 'construction', label: 'Construction / Engineering' },
  { value: 'energy', label: 'Energy / Utilities' },
  { value: 'renewable_energy', label: 'Renewable Energy / Clean Tech' },
  { value: 'oil_gas', label: 'Oil & Gas' },
  { value: 'retail', label: 'Retail / Consumer Goods' },
  { value: 'food_beverage', label: 'Food & Beverage' },
  { value: 'hospitality', label: 'Hospitality / Hotels' },
  { value: 'restaurants', label: 'Restaurants / Food Service' },
  { value: 'media', label: 'Media / Entertainment' },
  { value: 'gaming', label: 'Gaming / Esports' },
  { value: 'advertising', label: 'Advertising / Marketing' },
  { value: 'education', label: 'Education / EdTech' },
  { value: 'nonprofit', label: 'Non-Profit / NGO' },
  { value: 'government', label: 'Government / Public Sector' },
  { value: 'transportation', label: 'Transportation / Logistics' },
  { value: 'aviation', label: 'Aviation / Airlines' },
  { value: 'shipping', label: 'Shipping / Maritime' },
  { value: 'agriculture', label: 'Agriculture / Farming' },
  { value: 'telecommunications', label: 'Telecommunications' },
  { value: 'other', label: 'Other' },
];

export const CATEGORIES = [
  { id: 'education', label: 'Education', iconName: 'BookOpen' },
  { id: 'health', label: 'Health', iconName: 'Heart' },
  { id: 'environment', label: 'Environment', iconName: 'Leaf' },
  { id: 'animals', label: 'Animals', iconName: 'PawPrint' },
  { id: 'human_services', label: 'Human Services', iconName: 'Users' },
  { id: 'arts_culture', label: 'Arts & Culture', iconName: 'Palette' },
  { id: 'youth', label: 'Youth', iconName: 'User' },
];

export const CAUSE_OPTIONS = [
  { id: 'environment', label: 'Environment & Climate' },
  { id: 'education', label: 'Education & Youth' },
  { id: 'health', label: 'Health & Wellness' },
  { id: 'hunger', label: 'Hunger & Poverty' },
  { id: 'diversity', label: 'Diversity & Inclusion' },
  { id: 'community', label: 'Local Community' },
  { id: 'arts', label: 'Arts & Culture' },
  { id: 'animals', label: 'Animal Welfare' },
];

export const GEOGRAPHIC_OPTIONS = [
  { id: 'local', label: 'Local (City/Region)' },
  { id: 'state', label: 'State-wide' },
  { id: 'national', label: 'National (USA)' },
  { id: 'international', label: 'International/Global' },
];
